import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { MarketingFormPage } from './pages/MarketingFormPage';
import { ShipRequestFormPage } from './pages/ShipRequestFormPage';
import { ITSupportPage } from './pages/ITSupportPage';
import { CallbackPage } from './pages/CallbackPage';
import { SuccessPage } from './pages/SuccessPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AdminPage } from './pages/AdminPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AdminRoute } from './components/auth/AdminRoute';
import { ShipRequestRoute } from './components/auth/ShipRequestRoute';
import { oidcConfig, isOidcConfigured } from './lib/auth';

function AppRoutes() {
  const oidcEnabled = isOidcConfigured();

  return (
    <Routes>
      <Route path="/" element={oidcEnabled ? <LoginPage /> : <HomePage />} />
      <Route
        path="/portal"
        element={
          oidcEnabled ? (
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          ) : (
            <HomePage />
          )
        }
      />
      <Route
        path="/marketing"
        element={
          oidcEnabled ? (
            <ProtectedRoute>
              <MarketingFormPage />
            </ProtectedRoute>
          ) : (
            <MarketingFormPage />
          )
        }
      />
      <Route
        path="/ship-request"
        element={
          oidcEnabled ? (
            <ShipRequestRoute>
              <ShipRequestFormPage />
            </ShipRequestRoute>
          ) : (
            <ShipRequestFormPage />
          )
        }
      />
      <Route
        path="/admin"
        element={
          oidcEnabled ? (
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          ) : (
            <AdminPage />
          )
        }
      />
      <Route
        path="/it-support"
        element={
          oidcEnabled ? (
            <ProtectedRoute>
              <ITSupportPage />
            </ProtectedRoute>
          ) : (
            <ITSupportPage />
          )
        }
      />
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  const content = (
    <div className="w-full max-w-full min-w-0 overflow-x-hidden">
      <Router>
        <AppRoutes />
      </Router>
      {/* Build stamp — identifies stale tabs at a glance */}
      <div className="fixed bottom-1.5 right-2 text-[10px] text-muted pointer-events-none select-none z-50">
        build {__BUILD_TS__} · {__COMMIT_SHA__}
      </div>
    </div>
  );

  // Only wrap with AuthProvider if OIDC is configured
  if (isOidcConfigured()) {
    return <AuthProvider {...oidcConfig}>{content}</AuthProvider>;
  }

  return content;
}

export default App;
